<template>
    <div class="table">
        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.deptId" placeholder="请选择学校">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.classEvaluateType" placeholder="一级目录"></el-input>
                </div>
            </div>

            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.title" placeholder="二级目录"></el-input>
                </div>
            </div>
            &nbsp;
            <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
            <div style="display: inline-block; height:40px;float: right;">
                <el-button type="primary"  class="handle-del mr10" icon="el-icon-plus" @click="setAdd()">新增</el-button>
                <el-button type="primary"  class="handle-del mr10" icon="el-icon-delete" @click="batchDelete">批量删除</el-button>
            </div>
            
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                border
                default-expand-all
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="commonName" label="一级目录"  width="100" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="name" label="二级目录" width="100" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="pictureNumSet" label="允许上传图片个数" width="120"></el-table-column>
                <el-table-column prop="commonName2" label="拥有的指标" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="orderNum" label="排序号" width="60"></el-table-column>
                <el-table-column fixed="right" label="操作" width="110px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button  @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button style="color: red" @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!-- 新增/修改弹出框 -->
        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http'; 
    import add from './AddIndicators.vue';
    import update from './UpdateIndicators.vue';

    export default {
        name:"ClassEvaluateMain",
        data(){
            return{
                loading:false,
                addVisible:false,
                updateVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    id:"",
                    deptId:"",
                    title:"",
                    classEvaluateType:"",
                },
                data:[],
                depts:[]
            }
        },
        components: {
            add,update
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                let url  = this.classEvaluateIndicatorsSetListUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deptId:this.form.deptId,
                    name:this.form.title,
                    classEvaluateType:this.form.classEvaluateType
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.data = res.data.list;
                        this.common.total=res.data.total;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            //新增界面
            setAdd(){
                this.addVisible=true;
                this.$nextTick(() => {
                    this.$refs['add'].init(this.form.deptId);
                })
            },
            //修改界面
            setUpdate(data){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(data);
                })
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.classEvaluateIndicatorsSetRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            //批量删除
            batchDelete(){
                if(this.common.checkboxArr.length != 0){
                    let checkIdArr=new Array();
                    for(var i=0;i<this.common.checkboxArr.length;i++){
                        if(this.common.checkboxArr[i]!=1){
                            checkIdArr.push(this.common.checkboxArr[i]);
                        }
                    }
                    let idStr =checkIdArr.join(",");
                    this.form.id= idStr;
                    this.$commonFn.showConfirm(this.delSuccess);
                }
                else{
                    this.$commonFn.showTip("请选择删除数据",2);
                }
            },
            handleSelectionChange(val){
                this.common.checkboxArr = [];
                for (let i = 0;i < val.length;i++){
                    this.common.checkboxArr.push(val[i].id);
                }
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/classset/ClassEvaluateIndicatorsSet.vue